import { useContext } from "react";
import cx from "classnames";

import TextEllipsis from "ds/components/TextEllipsis";
import Typography, { TypographyProps } from "ds/components/Typography";

import styles from "./styles.module.css";
import { CardContext } from "../Context";

type CardTitleProps = TypographyProps;

const CardTitle = ({ variant, className, children, ...props }: CardTitleProps) => {
  const { size } = useContext(CardContext);
  const titleClass = cx(styles.title, size === "small" && styles.small, className);
  const isString = typeof children === "string";

  if (isString) {
    return (
      <TextEllipsis tooltip={children} tooltipWidthMode="maxWidthSm">
        {(ellipsisProps) => (
          <Typography
            variant={variant}
            {...props}
            {...ellipsisProps}
            className={cx(ellipsisProps.className, titleClass)}
          >
            {children}
          </Typography>
        )}
      </TextEllipsis>
    );
  }

  return (
    <Typography variant={variant} {...props} className={titleClass}>
      {children}
    </Typography>
  );
};

CardTitle.displayName = "DS.Card.Title";

export default CardTitle;
